import { __, invertObj, prop } from 'ramda';

import { EXPERTISE } from '../../../types/filters';

const PRISMIC_TO_TYPE_EXPERTISE = {
  Audiovisuel: EXPERTISE.AUDIOVISUAL,
  'Banque & assurance': EXPERTISE.BANK_INSURANCE,
  'Services-Courrier-Colis': EXPERTISE.COURRIER,
  Numérique: EXPERTISE.DIGITAL,
  Direction: EXPERTISE.TRANSVERSE, // Old prop for transverse
  Transverse: EXPERTISE.TRANSVERSE,
  'Transition énergétique': EXPERTISE.ENERGY,
  'Ressources humaines': EXPERTISE.HUMAN_RESOURCES,
  International: EXPERTISE.INTERNATIONAL,
  'La Poste Mobile': EXPERTISE.MOBILE,
  Partenariats: EXPERTISE.PARTNERS,
  'Logistique urbaine': EXPERTISE.URBAN,
};

export const toExpertiseType = prop(__, PRISMIC_TO_TYPE_EXPERTISE);
export const toExpertisePrismic = prop(
  __,
  invertObj(PRISMIC_TO_TYPE_EXPERTISE)
);
